export function parseTelegramUserFromHash() {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.slice(1));
    const raw = params.get('tgWebAppData');
    if (!raw) return null;

    const inner = new URLSearchParams(raw);
    const userJson = inner.get('user');
    if (!userJson) return null;

    try {
        return JSON.parse(decodeURIComponent(userJson));
    } catch (e) {
        console.error('Parse tgWebAppData.user failed', e);
        return null;
    }
}

export function getTelegramInfo() {
    const hashUser = parseTelegramUserFromHash();
    if (hashUser) {
        return {
            id: Number(hashUser.id),
            username: hashUser.username ? String(hashUser.username) : `tg_${hashUser.id}`
        };
    }
    const params = new URLSearchParams(window.location.search);
    const qTid = params.get('tid');
    if (qTid) return { id: Number(qTid), username: params.get('uname') || `tg_${qTid}` };

    if (window.Telegram?.WebApp?.initDataUnsafe?.user) {
        const u = window.Telegram.WebApp.initDataUnsafe.user;
        return { id: Number(u.id), username: u.username ? String(u.username) : `tg_${u.id}` };
    }

    return { id: 999999, username: 'tg_999999' };
}
